import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorsModule } from '@ddv/behaviors';
import { ColorInfo } from '@ddv/charts';

@Component({
    selector: 'ddv-multi-color-picker',
    templateUrl: './multi-color-picker.component.html',
    styleUrls: ['./multi-color-picker.component.scss'],
    imports: [CommonModule, BehaviorsModule],
})
export class MultiColorPickerComponent {
    @Input() colorValues: ColorInfo[] = [];
    @Input() backgroundStyle: string | undefined;
    @Input() dropdownClass: string | undefined;
    @Input() isReadOnly = false;

    @Output() colorSelected = new EventEmitter<{ color: string, el: HTMLElement }>();

    protected onColorSelected(color: string, el: HTMLElement): void {
        this.colorSelected.emit({ color, el });
    }
}
